import React, { Component } from "react";
import { WithWizard } from 'react-albus';
import { Button } from "reactstrap";

export class BottomNavigation extends Component {
    render() {
        return (
            <WithWizard render={({ next, previous, step, steps }) => {
                // Xác định xem có phải là bước đầu tiên hay cuối cùng không cho dễ đọc
                const isFirstStep = steps.indexOf(step) <= 0;
                const isLastStep = steps.indexOf(step) >= steps.length - 1;
                const { isLoading } = this.props; // Nhận prop isLoading

                return (
                    <div className={"wizard-buttons " + this.props.className}>
                        {/* Nút Previous: Giữ nguyên logic, chỉ ẩn ở bước đầu */}
                        <Button
                            color="primary"
                            className={"mr-1 btn-wizard"}
                            disabled={isFirstStep || isLoading}
                            onClick={() => { this.props.onClickPrev(previous, steps, step) }}
                        >
                            {this.props.prevLabel}
                        </Button>

                        {/* 
                            Nút Next: Chỉ hiển thị khi KHÔNG PHẢI là bước cuối cùng
                        */}
                        {!isLastStep && (
                            <Button
                                color="primary"
                                className={'btn-wizard'}
                                disabled={isLoading}
                                onClick={() => { this.props.onClickNext(next, steps, step) }}
                            >
                                {this.props.nextLabel}
                            </Button>
                        )}

                        {/* 
                            Nút Finish (Xong): Chỉ hiển thị KHI LÀ bước cuối cùng 
                        */}
                        {isLastStep && (
                            <Button
                                color="success" // Dùng màu khác để nhấn mạnh
                                className={'btn-wizard'}
                                disabled={isLoading}
                                onClick={this.props.onFinish} // Gọi hàm onFinish từ props
                            >
                                {isLoading ? "Đang xử lý..." : (this.props.finishLabel || "Hoàn tất")}
                            </Button>
                        )}
                    </div>
                );
            }} />
        )
    }
}
